"use strict";

module.exports = function () {

    return {
        selectedFacility: JSON.parse(localStorage.getItem("selectedFacility") || "{}"),
        activeUserFacilities: []
    };
};
